import axios from "axios";
import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import Card from "../../components/Card";
import {LoaderContext} from "../../context/LoaderContext";
import InfoCharts from "./InfoCharts";
import DataTableCmms from "../../components/tabelle/NsDataTable";


import {getDataFormattata, dateToMilliseconds, scadenza_warning, getTimestampFormattato} from "../../utility/common";

import {Tooltip as ReactTooltip} from "react-tooltip";


function DashboardStatiInstallazioni() {

    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState([]);
    const [installazioni, setInstallazioni] = useState([]);
    const [mappaDati, setMappaDati] = useState([]);

    const {startChiamata, endChiamata} = useContext(LoaderContext);


    const [InstallazioneSel, setInstallazioneSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const openModalDel = (installazione) => {
        setInstallazioneSel(installazione)
        setShowConfirm(true);
    }


    useEffect(() => {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/cmms/installazione/").then((response) => {
            let inst = response.data.data
            if (inst) {
                setInstallazioni(inst);
                setLoadingData(false);

                inst.forEach(inst => {
                    axios.get(inst.endpoint + "api/cmms/info/licenza/", {
                        headers: {
                            "Authorization" : `Bearer ${localStorage.getItem('cmms-login-inst')}`,
                            "jwt" : localStorage.getItem('cmms-login-inst'),
                        }
                    }).then((response) => {
                        let dataInst = response.data;

                        if (dataInst) {
                            setMappaDati(precMappaInfo => ({...precMappaInfo, [inst.id_installazione]: dataInst}));
                        }

                        endChiamata()
                    });
                });
            }

            endChiamata()
        });
    }, []);

    function getOpenApiSpecForInstallazione(installazione) {
        startChiamata();
        axios.get(installazione.endpoint + "api/cmms/info/openapi-specification/", {
            headers: {
                "Authorization" : `Bearer ${localStorage.getItem('cmms-login-inst')}`,
                "jwt" : localStorage.getItem('cmms-login-inst'),
            }
        }).then((response) => {
            const spec = response?.data?.data;

            if (spec) {
                const jsonData = JSON.stringify(spec);
                const blob = new Blob([jsonData], { type: 'application/json' });
                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = 'manu-openapi.json';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                URL.revokeObjectURL(url);
            }

            endChiamata();
        });
    }

    return (
        <Card
            icon={'fas fa-briefcase'}
            title={'Info Installazioni'}
        >
            <DataTableCmms
                data={installazioni}
                columns={[
                    {
                        name: 'Installazione',
                        selector: row => <div className="text-center">{row.descrizione}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            const descrizioneA = a?.descrizione ?? '';
                            const descrizioneB = b?.descrizione ?? '';

                            return descrizioneA.localeCompare(descrizioneB);
                        }

                    },
                    {
                        name: 'Partner',
                        selector: row => <div className="text-center">{row.partner}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            const partnerA = a?.partner ?? '';
                            const partnerB = b?.partner ?? '';
                            
                            return partnerA.localeCompare(partnerB);
                        }

                    },
                    {
                        name: 'Super Admin',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_superad - mappaDati[row.id_installazione].num_superad_attivi < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_superad - mappaDati[row.id_installazione].num_superad_attivi === 0) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? (mappaDati[row.id_installazione].num_superad_attivi + '/' + mappaDati[row.id_installazione].num_superad) : '-'}</div>,
                        sortable: false,
                    },
                    {
                        name: 'Supervisore',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_admin - mappaDati[row.id_installazione].num_admin_attivi < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_admin - mappaDati[row.id_installazione].num_admin_attivi === 0) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? (mappaDati[row.id_installazione].num_admin_attivi + '/' + mappaDati[row.id_installazione].num_admin) : '-'}</div>,
                        sortable: false,
                    },
                    {
                        name: 'Tecnico',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_tecnici - mappaDati[row.id_installazione].num_tecnici_attivi < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_tecnici - mappaDati[row.id_installazione].num_tecnici_attivi === 0) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? (mappaDati[row.id_installazione].num_tecnici_attivi + '/' + mappaDati[row.id_installazione].num_tecnici) : '-'}</div>,
                        sortable: false,
                    },
                    {
                        name: 'Guest',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_guest - mappaDati[row.id_installazione].num_guest_attivi < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].num_guest - mappaDati[row.id_installazione].num_guest_attivi === 0) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? (mappaDati[row.id_installazione].num_guest_attivi + '/' + mappaDati[row.id_installazione].num_guest) : '-'}</div>,
                        sortable: false,
                    },
                    {
                        name: 'Connettore API',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && ((mappaDati[row.id_installazione].num_api_enabled ?? 0) - (mappaDati[row.id_installazione].num_api_enabled_attivi ?? 0) < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && ((mappaDati[row.id_installazione].num_api_enabled ?? 0) - (mappaDati[row.id_installazione].num_api_enabled_attivi ?? 0) === 0) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? ((mappaDati[row.id_installazione].num_api_enabled_attivi ?? 0) + '/' + (mappaDati[row.id_installazione].num_api_enabled ?? 0)) : '-'}</div>,
                        sortable: false,
                    },
                    {
                        name: 'Spazio (GB)',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].max_space_disk - mappaDati[row.id_installazione].spazio_libero_gb < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && (mappaDati[row.id_installazione].max_space_disk - mappaDati[row.id_installazione].spazio_libero_gb === 0) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? (mappaDati[row.id_installazione].spazio_libero_gb + '/' + mappaDati[row.id_installazione].max_space_disk) : '-'}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            let dataA = mappaDati[a.id_installazione].spazio_libero_gb;
                            let dataB = mappaDati[b.id_installazione].spazio_libero_gb;

                            if (dataA < dataB) {
                                return -1;
                            }

                            if (dataA > dataB) {
                                return 1;
                            }

                            return 0;
                        }
                    },
                    {
                        name: 'Data scadenza',
                        selector: row => <div
                            className={` text-center ${mappaDati[row.id_installazione] && (dateToMilliseconds(mappaDati[row.id_installazione].data_scadenza) - dateToMilliseconds(Date.now()) < 0) ? 'text-danger fw-bold' :
                                mappaDati[row.id_installazione] && ((dateToMilliseconds(mappaDati[row.id_installazione].data_scadenza) - dateToMilliseconds(Date.now())) < scadenza_warning(1)) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] ? getDataFormattata(mappaDati[row.id_installazione].data_scadenza) : '-'}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            let dataA = dateToMilliseconds(mappaDati[a.id_installazione].data_scadenza);
                            let dataB = dateToMilliseconds(mappaDati[b.id_installazione].data_scadenza);

                            if (dataA < dataB) {
                                return -1;
                            }

                            if (dataA > dataB) {
                                return 1;
                            }

                            return 0;
                        }
                    },
                    
                    {
                        name: 'Data MTBF-MTTR',
                        selector: row => <div
                        className={` text-center ${mappaDati[row.id_installazione] && (dateToMilliseconds(mappaDati[row.id_installazione].data_scadenza_mtbf) - dateToMilliseconds(Date.now()) < 0) ? 'text-danger fw-bold' :
                            mappaDati[row.id_installazione] && ((dateToMilliseconds(mappaDati[row.id_installazione].data_scadenza_mtbf) - dateToMilliseconds(Date.now())) < scadenza_warning(1)) ? 'text-warning fw-bold' : ''}`}
                        >{mappaDati[row.id_installazione] && mappaDati[row.id_installazione].data_scadenza_mtbf && mappaDati[row.id_installazione].data_scadenza_mtbf !== ''
                            ? getTimestampFormattato(mappaDati[row.id_installazione].data_scadenza_mtbf) : '-'}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            if (mappaDati[a.id_installazione].data_scadenza_mtbf && mappaDati[a.id_installazione].data_scadenza_mtbf !== ''
                                && mappaDati[b.id_installazione].data_scadenza_mtbf && mappaDati[b.id_installazione].data_scadenza_mtbf !== '') {
                                let dataA = dateToMilliseconds(mappaDati[a.id_installazione].data_scadenza_mtbf);
                                let dataB = dateToMilliseconds(mappaDati[b.id_installazione].data_scadenza_mtbf);

                                if (dataA < dataB) {
                                    return -1;
                                }

                                if (dataA > dataB) {
                                    return 1;
                                }
                            }
                            return 0;
                        }
                    },
                    {
                        name: 'Ultimo login',
                        selector: row => <div
                            className={` text-center `}
                        >{mappaDati[row.id_installazione] && mappaDati[row.id_installazione].ultimo_login && mappaDati[row.id_installazione].ultimo_login !== ''
                            ? getTimestampFormattato(mappaDati[row.id_installazione].ultimo_login) : '-'}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            if (mappaDati[a.id_installazione].ultimo_login && mappaDati[a.id_installazione].ultimo_login !== ''
                                && mappaDati[b.id_installazione].ultimo_login && mappaDati[b.id_installazione].ultimo_login !== '') {
                                let dataA = dateToMilliseconds(mappaDati[a.id_installazione].ultimo_login);
                                let dataB = dateToMilliseconds(mappaDati[b.id_installazione].ultimo_login);

                                if (dataA < dataB) {
                                    return -1;
                                }

                                if (dataA > dataB) {
                                    return 1;
                                }
                            }
                            return 0;
                        }
                    },
                    {
                        name: 'Versione',
                        selector: row => <div
                            className="text-center">{mappaDati[row.id_installazione] ? (mappaDati[row.id_installazione].versione) : '-'}</div>,
                        sortable: true,
                        sortFunction: (a, b) => {
                            /*let A = dateToMilliseconds((mappaDati[a.id_installazione].versione).split(" ")[1]);
                            let B = dateToMilliseconds((mappaDati[b.id_installazione].versione).split(" ")[1]);
                            if (A < B) {
                                return -1;
                            }

                            if (A > B) {
                                return 1;
                            }

                            return 0;
                            */

                           //confronto versioni in base al numero, non alla data
                           const versioneA = mappaDati[a.id_installazione]?.versione ?? '';
                           const versioneB = mappaDati[b.id_installazione]?.versione ?? '';
                           
                           return versioneA.localeCompare(versioneB);
                        }
                    },

                    {
                        name: '',
                        selector: row => <div className="text-center">
                            <Link to={"/charts-installazione/" + row.id_installazione + '/' + row.descrizione}
                                  className="btn btn-dark cmms-btn-table"
                                  data-toggle="tooltip" data-tooltip-id="visualizza">
                                <span className={'cmms-display-mobile'}></span>

                                <span className="fa-stack small">
                                    <i className="fas fa-eye"></i>
                                </span>

                            </Link>
                            <ReactTooltip
                                id="visualizza"
                                place="top"
                                content="Clicca per visualizzare lo stato dell'installazione e/o modificare i suoi parametri"
                                style={{backgroundColor: "rgba(53,92,151,0.8)", color: "#fff", width: "200px"}}
                                className={"text-center"}
                            />
                            <button
                                onClick={() => getOpenApiSpecForInstallazione(row)}
                                className="btn btn-dark cmms-btn-table"
                                data-toggle="tooltip" data-tooltip-id="openapi">
                                <span className={'cmms-display-mobile'}></span>

                                <span className="fa-stack small">
                                    <i className="fas fa-download"></i>
                                </span>

                            </button>
                            <ReactTooltip
                                id="openapi"
                                place="top"
                                content="Clicca per scaricare la specifica OpenAPI degli endpoint abilitati"
                                style={{backgroundColor: "rgba(53,92,151,0.8)", color: "#fff", width: "200px"}}
                                className={"text-center"}
                            />
                        </div>,
                        sortable: false,
                        right: true,
                    }
                ]}
                funzioneFiltro={(item, filtro) => {
                    return (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
                }}

            >
            </DataTableCmms>

        </Card>
    );
}

export default DashboardStatiInstallazioni;